import React from "react";
import { Link } from "react-router-dom";
import { 
  Container, 
  Card 
} from "react-bootstrap";
import { Lock, ArrowLeft } from "lucide-react";

const ForbiddenPage = () => {
  return (
    <Container fluid className="min-vh-100 d-flex align-items-center justify-content-center" 
      style={{
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
      }}
    >
      <Card className="shadow-lg border-0" style={{ maxWidth: '500px', borderRadius: '20px' }}>
        <Card.Body className="text-center p-5">
          <div className="mb-4 d-flex justify-content-center">
            <div 
              className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center" 
              style={{ 
                width: '100px', 
                height: '100px', 
                background: 'linear-gradient(45deg, #ff416c, #ff4b2b)' 
              }}
            >
              <Lock size={48} strokeWidth={1.5} />
            </div>
          </div>
          
          <h1 className="display-4 fw-bold text-dark mb-3">
            403
            <span className="d-block text-muted h4 mt-2">Access Forbidden</span>
          </h1>
          
          <p className="text-secondary mb-4">
            You do not have the necessary permissions to access this page. 
            This area is restricted to authorized personnel only.
          </p>
          
          <div className="d-flex justify-content-center">
            <Link 
              to="/apps" 
              className="btn btn-outline-danger d-flex align-items-center"
            >
              <ArrowLeft className="me-2" size={20} />
              Return to home
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ForbiddenPage;